var $accordionTitles = document.querySelectorAll(".js-accordion-title");


function trackingEventPiwik(trackingObject, jsonData) {
    if(_paq && typeof _paq.push === 'function') {
        trackingObject.push(jsonData);
    }
}

    if (jQuery(".arc-page").length > 0) {
        for (let $accordionTitle of $accordionTitles) {
            const label = jQuery($accordionTitle).attr('data-label');
            const category = jQuery($accordionTitle).attr('data-category');
            $accordionTitle.addEventListener("click", () =>
                trackingEventPiwik(_paq, ["trackEvent", category, "Click", label])
            );
        }

        var $arcLinks = document.querySelectorAll(".arc-page__links");

        for (let $arcLink of $arcLinks) {

            $arcLink.addEventListener("click", () =>  trackingEventPiwik(_paq, ["trackEvent", "arc-page-link", "Click", jQuery($arcLink).text()]));


        }
    }

    if (jQuery(".contact-page").length > 0) {
        for (let $accordionTitle of $accordionTitles) {

            let title = $accordionTitle.querySelector(".accordion__title--label").innerHTML;
            $accordionTitle.addEventListener("click", function () {
                trackingEventPiwik(_paq, ["trackEvent", "Contattaci", "Click", title]);
            });

        }


    }

    if (jQuery(".single-inspiring-days").length > 0) {
        if(jQuery(".contact-section").length > 0)
        for (let $accordionTitle of $accordionTitles) {

            let title = $accordionTitle.querySelector(".accordion__title--label").innerHTML;
            $accordionTitle.addEventListener("click", function () {
                trackingEventPiwik(_paq, ["trackEvent", "Parliamo di Business - Inspiring Days", "Click", title]);
            });

        }


    }

    let contactCtaInspiringDays = document.querySelector(".contact-us-cta-inspiring-days");
    if (jQuery(contactCtaInspiringDays).length > 0) {
        contactCtaInspiringDays.addEventListener("click", function () {

            trackingEventPiwik(_paq, ["trackEvent", "CTA Contattaci - Dettaglio Inspiring Days", "Click", "Contattaci"]);

        });
    }

    let contactCtaTop = document.querySelector(".contact-us-cta-top");
    let contactCtaBottom = document.querySelector(".contact-us-cta-bottom");
    if (jQuery(contactCtaTop).length > 0) {
        contactCtaTop.addEventListener("click", function () {

            trackingEventPiwik(_paq, ["trackEvent", "CTA Contattaci Top - Dettaglio News", "Click", "Contattaci"]);


        });
    }
    if (jQuery(contactCtaBottom).length > 0) {
        contactCtaBottom.addEventListener("click", function () {

            trackingEventPiwik(_paq, ["trackEvent", "CTA Contattaci Bottom - Dettaglio News", "Click", "Contattaci"]);

        });
    }

    let detailInspiringDaysList = document.querySelectorAll(".inspiring-days-link-details");

    if (jQuery(detailInspiringDaysList).length > 0) {
        for (let element of detailInspiringDaysList) {
            element.addEventListener("click", function () {

                trackingEventPiwik(_paq, ["trackEvent", "Dettaglio Inspiring Days - Scopri di più", "Click", element.href]);

            });
        }
    }

    let detailNewsList = document.querySelectorAll(".news-link-details");

    if (jQuery(detailNewsList).length > 0) {
        for (let element of detailNewsList) {
            element.addEventListener("click", function () {

                trackingEventPiwik(_paq, ["trackEvent", "Dettaglio News - Scopri di più", "Click", element.href]);

            });
        }
    }

    let detailNewsTitleList = document.querySelectorAll(".detail-news");

    if (jQuery(detailNewsTitleList).length > 0) {
        for (let element of detailNewsTitleList) {
            element.addEventListener("click", function () {

                trackingEventPiwik(_paq, ["trackEvent", "Dettaglio News - Titolo", "Click", element.href]);

            });
        }
    }

    let externalNewsList = document.querySelectorAll(".external-link");

    if (jQuery(externalNewsList).length > 0) {
        for (let element of externalNewsList) {
            element.addEventListener("click", function () {

                trackingEventPiwik(_paq, ["trackEvent", "Link Esterno", "Click", element.href]);

            });
        }
    }


    let downloadCtaChristmas = document.querySelector(".download-cta-xmas");
    if (jQuery(downloadCtaChristmas).length > 0) {
        downloadCtaChristmas.addEventListener("click", function () {

            trackingEventPiwik(_paq, ["trackEvent", "Tombola Leo Burnett", "Download", "Tabellone Completo"]);
        });
    }

